export default __webpack_public_path__ + "static/media/gif01.07d8ecf6.gif";